<div class="order-history-qr">
  <qrcode width="275" [qrdata]="orderCode()"></qrcode>
  <div>заказ {{ orderCode() }}</div>
</div>
